export default function LogoMark({ className = "h-8 w-8" }) {
  return (
    <img
      src="/logo-emblem.png"
      alt="APSARA Kollektion Logo"
      className={`${className} object-contain`}
      aria-hidden="true"
    />
  );
}
